module.exports = __webpack_public_path__ + "static/media/banner_01.ad94988b.png";